import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

export default function SignIn() {
  const { signIn } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setErr('');
    try { await signIn(email, password); navigate('/'); }
    catch (_) { setErr('Invalid credentials'); }
    finally { setBusy(false); }
  }

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={submit}>
        <h1>Admin Sign In</h1>
        <div className="field"><input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} /></div>
        <div className="field"><input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} /></div>
        {err && <p style={{ color: '#dc3545', fontSize: 14 }}>{err}</p>}
        <button disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
      </form>
    </div>
  );
}
